export const paymentPlanCardTiers = {
  developer: 'developer',
  plus: 'plus',
  startup: 'startup',
  startup_v0: 'startup_v0',
  partner: 'partner',
  premier: 'premier',
  applyEnterprise: 'applyEnterprise',
};

export type PaymentPlanCardTiers = keyof typeof paymentPlanCardTiers;

export const tiersNeedingCard = [
  'premier',
  'startup',
  'startup_v0',
  'plus',
  'partner',
  'developer',
] as const;

export type TiersNeedingCard = (typeof tiersNeedingCard)[number];
